export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15001.e3ef47d7.jpg";